<!-- MAIN (Center website) -->

<head>
  <meta name="viewport" content="width=device-width, initial-scale=1.0">
</head>
<div class="page-container">
  <div class="header">
    <div class="logo header-content"></div>
    <ul class="user-actions header-content">
      <li>
        <a routerLink="/register" routerLinkActive="active">Sign Up</a>
      </li>

    </ul>
  </div>
  <div class="nav">
    <ul class="nav-options">
      <li>Our Product</li>
      <li>Plans </li>
      <li>Help</li>
      <li>Contact</li>
    </ul>
  </div>
</div>
<div class="loginForm">

  <br>
  <br>
  <br>
  <div class="container">
    <br>

    <h2>Enter your Login Information</h2>
    <form #loginForm="ngForm">
      <div [innerHTML]="innerHtml" class="text-center"> </div>
      <div class="form-group">
        <input required [(ngModel)]="user['email_id']" name="email_id" #email_id="ngModel" type="text" required
          placeholder="Registered Email-Id">
        <div class="alert alert-danger" *ngIf="email_id.touched && !email_id.valid">
          <img src="assets/images/icon-alert.png"> Fill this field
        </div>
        <input required [(ngModel)]="user['password']" name="password" #password="ngModel" required type="password"
          placeholder="Password">
        <div class="alert alert-danger" *ngIf="password.touched && !password.valid">
          <img src="assets/images/icon-alert.png">
          Password not given
        </div> <br>
        <div align="center">
          <button type="submit" [disabled]="!loginForm.valid" (click)="authUser()"
            class="btn primary-btn btnContactSubmit">Log-In</button>
        </div>
      </div>
      <div class="link">
        <a routerLink="/forgotpassword">Forgot password?</a>
      </div>
      <br>
      <input type="checkbox" class="remember" name="remember"> Remember me

      <span>
        <br> <br>
      </span>

    </form>

  </div>
</div>